import { DisplayInputValue } from '@reapitform/dashboard-ui'
import React from 'react'
import { IAgentSettingsData } from '../../../../../api/agent-settings'
import { InputFieldGroup, PersistentNotification } from '@reapitform/common-ui'
import { FlexContainer } from '@reapit/elements'

const PaymentMethodsDisplayView: React.FC<{ data?: null | IAgentSettingsData['paymentMethods'] }> = ({ data }) => {
  if (!data) return

  const directDebitData = data.directDebit
  const directCreditData = data.directCredit
  const bpayData = data.bpay
  const chequeData = data.cheque
  const cashData = data.cash
  const otherData = data.other
  const hasNotSelectedPaymentMethod = !(
    directCreditData ||
    directDebitData ||
    bpayData ||
    chequeData ||
    cashData ||
    otherData
  )

  return (
    <>
      {hasNotSelectedPaymentMethod && (
        <PersistentNotification icon="warning" intent="warning" isExpanded isInline>
          There are no payment methods available. Please add one or more methods.
        </PersistentNotification>
      )}
      {!hasNotSelectedPaymentMethod && (
        <FlexContainer isFlexColumn>
          {directDebitData && (
            <InputFieldGroup title="Direct Debit">
              <DisplayInputValue title="Type">{directDebitData.type}</DisplayInputValue>
            </InputFieldGroup>
          )}
          {directCreditData && (
            <InputFieldGroup title="Direct Credit">
              <DisplayInputValue title="Account Name">{directCreditData.accountName}</DisplayInputValue>
              <DisplayInputValue title="Bank Name">{directCreditData.bankName}</DisplayInputValue>
              <DisplayInputValue title="BSB">{directCreditData.bsb}</DisplayInputValue>
              <DisplayInputValue title="Account Number">{directCreditData.accountNumber}</DisplayInputValue>
            </InputFieldGroup>
          )}
          {bpayData && (
            <InputFieldGroup title="BPAY">
              <DisplayInputValue title="Biller Code">{bpayData.billerCode}</DisplayInputValue>
            </InputFieldGroup>
          )}
          {chequeData && (
            <InputFieldGroup title="Money Order / Cheque">
              <DisplayInputValue title="Payable To">{chequeData.payableTo}</DisplayInputValue>
            </InputFieldGroup>
          )}
          {cashData && (
            <InputFieldGroup title="Cash">
              <DisplayInputValue title="Place of Payment">{cashData.placeOfPayment}</DisplayInputValue>
            </InputFieldGroup>
          )}
          {otherData && (
            <InputFieldGroup title="Others">
              <DisplayInputValue title="Details">{otherData.type}</DisplayInputValue>
            </InputFieldGroup>
          )}
        </FlexContainer>
      )}
    </>
  )
}

export default PaymentMethodsDisplayView
